<template>

    <div class="row">
        <div class="col-sm-6 col-sm-offset-3">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Zoekresultaten voor: {{ $route.query.search }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Onderdeel</th>
                                <th>Naam</th>
                                <th>Actie</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="data.length === 0"><td colspan="3">Er zijn geen resultaten gevonden</td></tr>
                            <tr v-for="entry in data">
                                <td>{{ entry.section }}</td>
                                <td>{{ entry.name }}</td>
                                <td>
                                    <router-link
                                        :to="{name:entry.route.name, params:entry.route.params}"
                                        class="btn btn-default btn-xs"
                                    >
                                        <i class="mdi mdi-eye"></i>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--<div class="box-body text-center">
                    {{ $results->links() }}
                </div>-->
            </div>
        </div>
    </div>

</template>

<script>

import Lang from "../../Lang";
import axios from "axios";

export default {

    data() {
        return {
            lang:Lang,
            loading:true,
            data:[],
            links:{},
            meta:{},
        }
    },

    methods: {
        getSearchResults() {
            this.loading = true;

            if (this.$route.query.search === '') {
                this.results = [];
                this.loading = false;
                return false;
            }

            axios.post(this.route('api.v1.search.results'), {searchvalue: this.$route.query.search})
                .then(resp => {
                    this.data = resp.data.data;
                    this.links = resp.data.links;
                    this.meta = resp.data.meta;
                })
                .finally(() => this.loading = false);
        }
    },

    metaInfo: {
        title:'Zoekresultaten',
    },

    mounted(){
        this.getSearchResults();
    },

    name:'SearchResults',
}

</script>
